import React from 'react';
import './Apk.css';

export default function Apk() {
    return (
        <div className="apk-page">
            <div className="apk-content">
                <img src="/images/audit.jpg" alt="Auditusierp" className="apk-icon" />

                <h1 className="apk-title">Auditusierp CRM </h1>
                <p className="apk-subtitle">Download the latest version of the app (.apk)</p>


                <a href="/Download/Auditus-ierpCRM.apk" className="apk-download-button" download>
                    Download APK
                </a>

                <div className="apk-instructions">
                    <h2>How to Install</h2>
                    <ol>
                        <li>Download the APK file using the button above.</li>
                        <li>Open your File Manager and locate the downloaded file.</li>
                        <li>Tap the file and follow the prompts to install the app.</li>
                        <li>If your phone blocks the install, go to <strong>Settings &gt; Security</strong> and enable <strong>Install from Unknown Sources</strong>.</li>
                        <li>After installation, go to your device's <strong>App Info</strong> for the installed app.</li>
                        <li>Tap on <strong>Permissions</strong> and allow required permissions like:</li>
                        <ul>
                            <li><strong>Call</strong> – to make and manage phone calls.</li>
                            <li><strong>Contacts</strong> – if your app needs access to contact info.</li>
                            <li><strong>Storage</strong> – to save or read files locally.</li>
                            <li><strong>Location</strong> – if needed for GPS-based features.</li>
                        </ul>
                        <li>Once permissions are allowed, return to the app and enjoy full functionality.</li>
                    </ol>
                </div>


                
            </div>
        </div>
    );
}
